export type Language = 'fr' | 'en';

export const translations = {
  fr: {
    // Navbar
    callNow: "Appelez maintenant",
    adminArea: "Espace Admin",
    // Home
    operationalExcellence: "Excellence Opérationnelle",
    certifiedPECB: "Certifié PECB",
    accreditedIAS: "Accrédité IAS",
    learnMore: "En savoir plus",
    metrologyPrecision: "Métrologie & Précision",
    requestCalibrationQuote: "Demander un devis d'étalonnage",
    authorizedPartner: "Partenaire Autorisé",
    accredited: "Accrédité",
    heroTitle: "Votre partenaire vers <br /><span class=\"text-transparent bg-clip-text bg-gradient-to-r from-be-france to-be-sky\">l'Excellence.</span>",
    heroSubtitle: "Diagnostic, Conseil, Audit et Accompagnement sur mesure en Afrique Centrale. Transformez vos défis réglementaires en leviers de performance.",
    discoverServices: "Découvrir nos services",
    freeQuote: "Devis gratuit",
    whyChooseUs: "Pourquoi nous choisir ?",
    whyChooseUsSubtitle: "Une approche pragmatique et orientée résultats pour garantir votre succès.",
    expertise: "Expertise Reconnue",
    expertiseDesc: "Des consultants certifiés avec plus de 10 ans d'expérience.",
    tailorMade: "Solutions Sur-Mesure",
    tailorMadeDesc: "Des approches adaptées à la taille et au secteur de votre entreprise.",
    support: "Accompagnement Continu",
    supportDesc: "Un suivi rigoureux de la conception à la certification finale.",
    ourPartners: "Ils nous font confiance",
    
    // New DNA Section
    dnaTitle: "L'ADN de BE Consulting",
    dnaSubtitle: "Découvrez les fondements de notre engagement envers votre réussite.",
    whoWeAre: "Qui sommes-nous ?",
    whoWeAreDesc: "Un cabinet d'expertise pluridisciplinaire basé à Douala, dédié à l'accompagnement des entreprises vers la performance durable à travers le conseil, l'audit et la formation.",
    vision: "Notre Vision",
    visionDesc: "Devenir le levier stratégique incontournable et le partenaire de référence pour l'excellence opérationnelle en Afrique Centrale.",
    missions: "Nos Missions",
    missionsDesc: "Transformer les contraintes normatives en opportunités de croissance, sécuriser vos actifs et renforcer le capital humain de votre organisation.",
    values: "Nos Valeurs",
    valuesDesc: "Intégrité, Rigueur Professionnelle, Innovation constante et Proximité client sont au cœur de chacune de nos interventions.",
    slogan: "Notre Slogan",
    sloganDesc: "When Mission Meets Value",

    // Services
    servicesTitle: "Nos Solutions",
    servicesSubtitle: "Une expertise technique pointue pour répondre aux exigences normatives et améliorer la performance de votre entreprise.",
    requestIntervention: "Demander une intervention",
    methodologiesDesc: "Nous mettons en œuvre des méthodologies éprouvées pour garantir des résultats tangibles et durables.",
    
    // Training
    trainingTitle: "Institut de Formation",
    trainingSubtitle: "Renforcez le capital humain de votre entreprise avec des modules certifiants et une pédagogie axée sur le résultat.",
    targetAudience: "Public Cible",
    addedValue: "Valeur ajoutée",
    requestQuote: "Demander un devis",
    customTraining: "Formation À LA CARTE",
    customTrainingDesc: "Vous avez des besoins spécifiques non couverts par notre catalogue standard ? Nos experts conçoivent des programmes pédagogiques personnalisés, adaptés à votre secteur d'activité et à vos objectifs stratégiques.",
    caseStudy: "Étude de cas sur vos propres données",
    flexibleHours: "Horaires et lieux flexibles (Intra)",
    postTrainingCoaching: "Coaching post-formation inclus",
    contactForProject: "Nous contacter pour un projet",
    annualSchedule: "Planning Annuel",
    annualScheduleDesc: "Téléchargez notre catalogue complet incluant les tarifs et le calendrier détaillé des prochaines sessions inter-entreprises à Douala et Yaoundé.",
    downloadCatalog: "Télécharger le Catalogue",
    custom: "Sur mesure",
    customDesc: "Entreprises avec des besoins spécifiques non couverts par notre catalogue standard.",

    // Software
    digitalDivision: "Pôle Numérique",
    itSolutionsTitle: "Nos Solutions Informatiques",
    itSolutionsSubtitle: "Des services technologiques adaptés aux PME et grandes entreprises.",
    customUpper: "SUR MESURE",
    sageExpertise: "Expertise SAGE",
    sageExpertiseDesc: "En tant qu'intégrateur, nous maîtrisons l'écosystème SAGE pour optimiser votre gestion financière et commerciale. Nous assurons également la formation de vos collaborateurs.",
    viewSageTraining: "Voir les formations SAGE",
    contactSageExpert: "Contactez un expert SAGE",
    softwareTitle: "Solutions Logicielles",
    softwareSubtitle: "Optimisez votre gestion avec les solutions SAGE et notre expertise en intégration IT.",
    sageIntegration: "Intégration SAGE",
    sageIntegrationDesc: "Déploiement, paramétrage et formation sur les solutions SAGE Comptabilité, Paie et Gestion Commerciale.",
    itMaintenance: "Maintenance Informatique",
    itMaintenanceDesc: "Support technique réactif, maintenance préventive et curative de votre parc informatique.",
    networkSecurity: "Réseaux & Sécurité",
    networkSecurityDesc: "Conception, installation et sécurisation de vos infrastructures réseaux d'entreprise.",
    contactExpert: "Contacter un expert IT",

    // Contact
    contactTitle: "Contactez-nous",
    contactSubtitle: "Notre équipe d'experts est à votre écoute pour définir vos besoins et optimiser vos performances.",
    sendMessage: "Envoyez-nous un message",
    messageSent: "Message envoyé avec succès !",
    messageSentDesc: "Nous avons bien reçu votre demande. Un consultant reviendra vers vous sous 24h ouvrées.",
    sendAnotherMessage: "Envoyer un autre message",
    fullName: "Nom complet",
    company: "Entreprise",
    professionalEmail: "Email Professionnel",
    requestSubject: "Sujet de votre demande",
    message: "Message",
    networkError: "Une erreur réseau est survenue. Veuillez réessayer ultérieurement.",
    sending: "Envoi en cours...",
    sendButton: "Envoyer le message",
    ourContactInfo: "Nos Coordonnées",
    physicalAddress: "Adresse Physique",
    phoneWhatsapp: "Téléphone / WhatsApp",
    directEmail: "Email Direct",
    openingHours: "Heures d'ouverture",
    openingHoursDesc: "Lundi - Vendredi : 08h00 - 17h30",
    messageReceived: "Message bien reçu !",
    messageSuccess: "Nous avons bien reçu votre demande. Un consultant reviendra vers vous sous 24h ouvrées.",
    sendAnother: "Envoyer un autre message",
    yourName: "Votre nom",
    yourCompany: "Votre entreprise",
    messagePlaceholder: "Comment pouvons-nous vous aider ?",
    formError: "Une erreur est survenue. Veuillez réessayer.",
    submitting: "Envoi en cours...",
    submitButton: "Envoyer le message",
    ourDetails: "Nos Coordonnées",
    hoursDetails: "Lundi - Vendredi : 08h00 - 17h30",

    // Footer
    quickLinks: "Liens Rapides",
    legal: "Légal",
    legalMentions: "Mentions Légales",
    privacyPolicy: "Politique de Confidentialité",
    termsOfService: "Conditions d'utilisation",
    allRightsReserved: "Tous droits réservés.",
    footerNavigation: "Navigation",
    footerContactUs: "Contactez-nous",
    footerNewsletter: "Newsletter",
    footerAbout: "À Propos",
    footerDescription: "Nous sommes à vos côtés pour la réussite de votre projet. Notre gamme complète de services est conçue pour vous conduire vers l'excellence opérationnelle.",
    whatsappTelLabel: "WhatsApp / Tél.",
    stayInformed: "Restez informé",
    newsletterDescImg: "Inscrivez-vous pour recevoir nos dernières actualités et offres.",
    newsletterPlaceholder: "Votre email",
    subscribeBtn: "S'INSCRIRE",
    designedWith: "Conçu avec",
    by: "par",

    // Floating Controls
    email: "Email",
    phone: "Téléphone",
    whatsapp: "WhatsApp",
    scrollToTop: "Retour en haut",
    needHelp: "Besoin d'aide ?",

    // Legal Pages
    legalMentionsTitle: "Mentions Légales",
    privacyPolicyTitle: "Politique de Confidentialité",
    termsTitle: "Conditions Générales d'Utilisation (CGU)",
    legalNotice: "Mentions Légales",
    sitePublisher: "Éditeur du site",
    publisherText: "Le présent site est édité par",
    publisherDesc: "cabinet de conseil, d'audit et de formation.",
    legalForm: "Forme juridique",
    headOffice: "Siège social",
    niu: "NIU",
    rccm: "RCCM",
    publicationDirector: "Directeur de la publication",
    hosting: "Hébergement",
    hostingText: "Le site est hébergé par",
    hostingAddress: "située à San Francisco, Californie, États-Unis.",
    intellectualProperty: "Propriété Intellectuelle",
    ipText: "L'ensemble du contenu de ce site (textes, images, vidéos, logos) est la propriété exclusive de BE Consulting & Services, sauf mention contraire. Toute reproduction, distribution, modification ou publication de ces éléments est strictement interdite sans notre accord écrit préalable.",
    designDevelopment: "Conception et Développement",
    designText: "Le site a été conçu et développé par l'agence web",
    privacyIntro: "La présente politique de confidentialité a pour but de vous informer sur la manière dont",
    privacyIntro2: "collecte, utilise et protège vos données personnelles lorsque vous utilisez notre site web.",
    dataCollected: "Données collectées",
    dataCollectedText: "Nous collectons uniquement les données strictement nécessaires au traitement de vos demandes :",
    contactForm: "Formulaire de contact",
    contactFormFields: "Nom, entreprise, adresse email professionnelle, sujet et contenu du message.",
    newsletterField: "Adresse email pour l'envoi de nos actualités.",
    technicalData: "Données techniques",
    technicalDataDesc: "Adresse IP, type de navigateur, pages visitées (à des fins statistiques via des cookies essentiels).",
    dataUse: "Utilisation des données",
    dataUseText: "Vos données personnelles sont utilisées pour :",
    dataUse1: "Répondre à vos demandes de contact ou de devis.",
    dataUse2: "Vous envoyer notre newsletter (si vous y avez souscrit).",
    dataUse3: "Améliorer l'expérience utilisateur sur notre site.",
    noDataSale: "Nous ne vendons, ne louons ni ne cédons vos données personnelles à des tiers.",
    yourRights: "Vos droits",
    rightsText: "Conformément à la réglementation en vigueur, vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition concernant vos données personnelles. Pour exercer ces droits, veuillez nous contacter à l'adresse :",
    security: "Sécurité",
    securityText: "Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles pour protéger vos données contre tout accès non autorisé, perte ou altération.",
    purpose: "Objet",
    purposeText: "Les présentes CGU ont pour objet de définir les modalités et conditions dans lesquelles BE Consulting & Services met à disposition de ses utilisateurs le site be-consulting.pro et les services disponibles sur le site.",
    siteAccess: "Accès au site",
    siteAccessText: "L'accès au site est gratuit. Les frais d'accès et d'utilisation du réseau de télécommunication sont à la charge de l'utilisateur, selon les modalités fixées par ses fournisseurs d'accès et opérateurs de télécommunication.",
    liability: "Responsabilité",
    liabilityText: "BE Consulting s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur ce site. Toutefois, nous ne pouvons garantir l'exactitude, la précision ou l'exhaustivité des informations mises à disposition. L'utilisateur est seul responsable de l'utilisation qu'il fait de ces informations.",
    hyperlinks: "Liens hypertextes",
    hyperlinksText: "Le site peut contenir des liens hypertextes vers d'autres sites. BE Consulting n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu.",
    applicableLaw: "Droit applicable",
    applicableLawText: "Les présentes conditions sont régies par le droit camerounais. Tout litige relatif à l'interprétation ou à l'exécution des présentes sera de la compétence exclusive des tribunaux de Douala.",

    // Admin Dashboard
    incorrectPassword: "Mot de passe incorrect",
    confirmDeleteMessage: "Supprimer ce message définitivement ?",
    confirmDeleteSubscriber: "Supprimer cet abonné ?",
    adminAccess: "Accès Administrateur",
    enterAccessCode: "Veuillez saisir votre code d'accès.",
    password: "Mot de passe",
    login: "Se connecter",
    adminConsole: "Console Administrateur",
    centralizedManagement: "Gestion centralisée des leads et de l'audience.",
    exportCSV: "Export CSV",
    logout: "Quitter",
    messages: "Messages",
    subscribers: "Abonnés",
    unread: "Non lus",
    contactMessages: "Messages Contact",
    search: "Rechercher...",
    resetFilters: "Réinitialiser les filtres",
    status: "Statut",
    date: "Date",
    sender: "Émetteur",
    subject: "Sujet",
    actions: "Actions",
    noMessagesFound: "Aucun message trouvé.",
    new: "Nouveau",
    read: "Lu",
    replied: "Répondu",
    markAsRead: "Marquer comme lu",
    markAsReplied: "Marquer comme répondu",
    delete: "Supprimer",
    subscriberEmail: "Email Abonné",
    subscriptionDate: "Date d'inscription",
    noSubscribersFound: "Aucun abonné trouvé.",
    dataStoredLocally: "Données stockées localement en toute sécurité pour cette démonstration.",
    subscriptionSuccess: "Merci pour votre inscription !",

    // Chatbot
    chatbotWelcome: "Bonjour ! Comment pouvons-nous vous aider vers l'excellence opérationnelle aujourd'hui ?",
    chatbotReply: "Merci pour votre message. Un expert de BE Consulting vous répondra sous peu.",
    chatbotTitle: "Assistant BE Consulting",
    yourMessage: "Votre message...",
  },
  en: {
    // Navbar
    callNow: "Call Now",
    adminArea: "Admin Area",
    // Home
    operationalExcellence: "Operational Excellence",
    certifiedPECB: "PECB Certified",
    accreditedIAS: "IAS Accredited",
    learnMore: "Learn more",
    metrologyPrecision: "Metrology & Precision",
    requestCalibrationQuote: "Request a calibration quote",
    authorizedPartner: "Authorized Partner",
    accredited: "Accredited",
    heroTitle: "Your partner towards <br /><span class=\"text-transparent bg-clip-text bg-gradient-to-r from-be-france to-be-sky\">Excellence.</span>",
    heroSubtitle: "Diagnostics, Consulting, Audit and Tailor-made Support in Central Africa. Transform your regulatory challenges into performance levers.",
    discoverServices: "Discover our services",
    freeQuote: "Free quote",
    whyChooseUs: "Why choose us?",
    whyChooseUsSubtitle: "A pragmatic and results-oriented approach to guarantee your success.",
    expertise: "Recognized Expertise",
    expertiseDesc: "Certified consultants with over 10 years of experience.",
    tailorMade: "Tailor-Made Solutions",
    tailorMadeDesc: "Approaches adapted to the size and sector of your company.",
    support: "Continuous Support",
    supportDesc: "Rigorous follow-up from design to final certification.",
    ourPartners: "They trust us",
    
    // New DNA Section
    dnaTitle: "BE Consulting DNA",
    dnaSubtitle: "Discover the foundations of our commitment to your success.",
    whoWeAre: "Who are we?",
    whoWeAreDesc: "A multidisciplinary expertise firm based in Douala, dedicated to supporting companies towards sustainable performance through consulting, audit, and training.",
    vision: "Our Vision",
    visionDesc: "To become the essential strategic lever and the reference partner for operational excellence in Central Africa.",
    missions: "Our Missions",
    missionsDesc: "Transform normative constraints into growth opportunities, secure your assets, and strengthen your organization's human capital.",
    values: "Our Values",
    valuesDesc: "Integrity, Professional Rigor, Constant Innovation, and Client Proximity are at the heart of each of our interventions.",
    slogan: "Our Slogan",
    sloganDesc: "When Mission Meets Value",

    // Services
    servicesTitle: "Our Solutions",
    servicesSubtitle: "Advanced technical expertise to meet regulatory requirements and improve your company's performance.",
    requestIntervention: "Request an intervention",
    methodologiesDesc: "We implement proven methodologies to ensure tangible and lasting results.",
    
    // Training
    trainingTitle: "Training Institute",
    trainingSubtitle: "Strengthen your company's human capital with certifying modules and a results-oriented pedagogy.",
    targetAudience: "Target Audience",
    addedValue: "Added Value",
    requestQuote: "Request a quote",
    customTraining: "CUSTOM Training",
    customTrainingDesc: "Do you have specific needs not covered by our standard catalog? Our experts design personalized educational programs, adapted to your sector of activity and your strategic objectives.",
    caseStudy: "Case study on your own data",
    flexibleHours: "Flexible hours and locations (In-house)",
    postTrainingCoaching: "Post-training coaching included",
    contactForProject: "Contact us for a project",
    annualSchedule: "Annual Schedule",
    annualScheduleDesc: "Download our complete catalog including prices and the detailed schedule of upcoming inter-company sessions in Douala and Yaoundé.",
    downloadCatalog: "Download the Catalog",
    custom: "Custom",
    customDesc: "Companies with specific needs not covered by our standard catalog.",

    // Software
    digitalDivision: "Digital Division",
    itSolutionsTitle: "Our IT Solutions",
    itSolutionsSubtitle: "Technological services adapted to SMEs and large companies.",
    customUpper: "CUSTOM",
    sageExpertise: "SAGE Expertise",
    sageExpertiseDesc: "As an integrator, we master the SAGE ecosystem to optimize your financial and commercial management. We also provide training for your employees.",
    viewSageTraining: "View SAGE training",
    contactSageExpert: "Contact a SAGE expert",
    softwareTitle: "Software Solutions",
    softwareSubtitle: "Optimize your management with SAGE solutions and our IT integration expertise.",
    sageIntegration: "SAGE Integration",
    sageIntegrationDesc: "Deployment, configuration, and training on SAGE Accounting, Payroll, and Commercial Management solutions.",
    itMaintenance: "IT Maintenance",
    itMaintenanceDesc: "Responsive technical support, preventive and curative maintenance of your IT equipment.",
    networkSecurity: "Networks & Security",
    networkSecurityDesc: "Design, installation, and securing of your corporate network infrastructures.",
    contactExpert: "Contact an IT expert",

    // Contact
    contactTitle: "Contact Us",
    contactSubtitle: "Our team of experts is at your disposal to define your needs and optimize your performance.",
    sendMessage: "Send us a message",
    messageSent: "Message sent successfully!",
    messageSentDesc: "We have received your request. A consultant will get back to you within 24 business hours.",
    sendAnotherMessage: "Send another message",
    fullName: "Full Name",
    company: "Company",
    professionalEmail: "Professional Email",
    requestSubject: "Subject of your request",
    message: "Message",
    networkError: "A network error has occurred. Please try again later.",
    sending: "Sending...",
    sendButton: "Send message",
    ourContactInfo: "Our Contact Info",
    physicalAddress: "Physical Address",
    phoneWhatsapp: "Phone / WhatsApp",
    directEmail: "Direct Email",
    openingHours: "Opening Hours",
    openingHoursDesc: "Monday - Friday : 08:00 AM - 05:30 PM",
    messageReceived: "Message received!",
    messageSuccess: "We have received your request. A consultant will get back to you within 24 business hours.",
    sendAnother: "Send another message",
    yourName: "Your name",
    yourCompany: "Your company",
    messagePlaceholder: "How can we help you?",
    formError: "An error occurred. Please try again.",
    submitting: "Submitting...",
    submitButton: "Send message",
    ourDetails: "Our Details",
    hoursDetails: "Monday - Friday: 08:00 AM - 05:30 PM",

    // Footer
    quickLinks: "Quick Links",
    legal: "Legal",
    legalMentions: "Legal Mentions",
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service",
    allRightsReserved: "All rights reserved.",
    footerNavigation: "Navigation",
    footerContactUs: "Contact Us",
    footerNewsletter: "Newsletter",
    footerAbout: "About Us",
    footerDescription: "We are by your side for the success of your project. Our complete range of services is designed to lead you towards operational excellence.",
    whatsappTelLabel: "WhatsApp / Tel.",
    stayInformed: "Stay informed",
    newsletterDescImg: "Sign up to receive our latest news and offers.",
    newsletterPlaceholder: "Your email",
    subscribeBtn: "SUBSCRIBE",
    designedWith: "Designed with",
    by: "by",

    // Floating Controls
    email: "Email",
    phone: "Phone",
    whatsapp: "WhatsApp",
    scrollToTop: "Scroll to top",
    needHelp: "Need help?",

    // Legal Pages
    legalMentionsTitle: "Legal Mentions",
    privacyPolicyTitle: "Privacy Policy",
    termsTitle: "Terms of Service",
    legalNotice: "Legal Notice",
    sitePublisher: "Site Publisher",
    publisherText: "This site is published by",
    publisherDesc: "consulting, audit, and training firm.",
    legalForm: "Legal Form",
    headOffice: "Head Office",
    niu: "NIU",
    rccm: "RCCM",
    publicationDirector: "Publication Director",
    hosting: "Hosting",
    hostingText: "The site is hosted by",
    hostingAddress: "located in San Francisco, California, USA.",
    intellectualProperty: "Intellectual Property",
    ipText: "All content on this site (texts, images, videos, logos) is the exclusive property of BE Consulting & Services, unless otherwise stated. Any reproduction, distribution, modification, or publication of these elements is strictly prohibited without our prior written consent.",
    designDevelopment: "Design and Development",
    designText: "The site was designed and developed by the web agency",
    privacyIntro: "The purpose of this privacy policy is to inform you about how",
    privacyIntro2: "collects, uses, and protects your personal data when you use our website.",
    dataCollected: "Data Collected",
    dataCollectedText: "We only collect data strictly necessary to process your requests:",
    contactForm: "Contact Form",
    contactFormFields: "Name, company, professional email address, subject, and message content.",
    newsletterField: "Email address for sending our news.",
    technicalData: "Technical Data",
    technicalDataDesc: "IP address, browser type, pages visited (for statistical purposes via essential cookies).",
    dataUse: "Data Use",
    dataUseText: "Your personal data is used to:",
    dataUse1: "Respond to your contact or quote requests.",
    dataUse2: "Send you our newsletter (if you have subscribed).",
    dataUse3: "Improve the user experience on our site.",
    noDataSale: "We do not sell, rent, or transfer your personal data to third parties.",
    yourRights: "Your Rights",
    rightsText: "In accordance with current regulations, you have the right to access, rectify, delete, and oppose your personal data. To exercise these rights, please contact us at:",
    security: "Security",
    securityText: "We implement technical and organizational security measures to protect your data against unauthorized access, loss, or alteration.",
    purpose: "Purpose",
    purposeText: "The purpose of these Terms of Service is to define the terms and conditions under which BE Consulting & Services makes the be-consulting.pro site and the services available on the site available to its users.",
    siteAccess: "Access to the site",
    siteAccessText: "Access to the site is free. The costs of access and use of the telecommunications network are the responsibility of the user, according to the terms set by their access providers and telecommunications operators.",
    liability: "Liability",
    liabilityText: "BE Consulting strives to ensure the accuracy and updating of the information published on this site. However, we cannot guarantee the accuracy, precision, or completeness of the information made available. The user is solely responsible for the use they make of this information.",
    hyperlinks: "Hyperlinks",
    hyperlinksText: "The site may contain hyperlinks to other sites. BE Consulting has no control over these sites and declines all responsibility for their content.",
    applicableLaw: "Applicable Law",
    applicableLawText: "These conditions are governed by Cameroonian law. Any dispute relating to the interpretation or execution of these terms shall be the exclusive jurisdiction of the courts of Douala.",

    // Admin Dashboard
    incorrectPassword: "Incorrect password",
    confirmDeleteMessage: "Permanently delete this message?",
    confirmDeleteSubscriber: "Delete this subscriber?",
    adminAccess: "Administrator Access",
    enterAccessCode: "Please enter your access code.",
    password: "Password",
    login: "Login",
    adminConsole: "Administrator Console",
    centralizedManagement: "Centralized management of leads and audience.",
    exportCSV: "Export CSV",
    logout: "Logout",
    messages: "Messages",
    subscribers: "Subscribers",
    unread: "Unread",
    contactMessages: "Contact Messages",
    search: "Search...",
    resetFilters: "Reset filters",
    status: "Status",
    date: "Date",
    sender: "Sender",
    subject: "Subject",
    actions: "Actions",
    noMessagesFound: "No messages found.",
    new: "New",
    read: "Read",
    replied: "Replied",
    markAsRead: "Mark as read",
    markAsReplied: "Mark as replied",
    delete: "Delete",
    subscriberEmail: "Subscriber Email",
    subscriptionDate: "Subscription Date",
    noSubscribersFound: "No subscribers found.",
    dataStoredLocally: "Data stored locally securely for this demonstration.",
    subscriptionSuccess: "Thank you for subscribing!",

    // Chatbot
    chatbotWelcome: "Hello! How can we help you towards operational excellence today?",
    chatbotReply: "Thank you for your message. A BE Consulting expert will reply shortly.",
    chatbotTitle: "BE Consulting Assistant",
    yourMessage: "Your message...",
  }
};